import _ from 'underscore';
import templateStr from 'text!./pa-confirmation.html';
import './pa-confirmation.scss';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,

        controller: ['$scope', function ($scope) {
            this._getCoveragesForVehicle = function (veh) {
                return veh.coverages.filter(function (cov) {
                    return cov.selected;
                }).map(function (vehicleCov) {
                    return {
                        name: veh.vehicleName + ' - ' + vehicleCov.name,
                        amount: vehicleCov.amount
                    };
                });
            };

            this._coverages = function () {
                var lineCoverages = $scope.chosenQuote.lobs.personalAuto.lineCoverages.filter(function (cov) {
                    return cov.selected;
                }).map(function (lineCov) {
                    return {
                        name: lineCov.name,
                        amount: lineCov.amount
                    };
                });
                var coveragesForVehicles = $scope.chosenQuote.lobs.personalAuto.vehicleCoverages.map(this._getCoveragesForVehicle);

                return lineCoverages.concat(_.flatten(coveragesForVehicles));
            };

            $scope.coverages = this._coverages();
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/pa/directives/pa-confirmation/PAConfirmation.js
// module id = 2173
// module chunks = 0